import i18n from 'i18next';
import {registerLocale, setDefaultLocale} from 'react-datepicker';

import {I18N_NS} from '../constants/names';

import enUsTranslation from './en-us.json';
import frTranslation from './fr.json';

import {locales, Locales} from './index';

if (!i18n.hasResourceBundle(Locales.en, I18N_NS)) {
    i18n.addResourceBundle(Locales.en, I18N_NS, enUsTranslation, true, true);
} else {
    i18n.addResourceBundle(Locales.en, I18N_NS, enUsTranslation, true, true);
}

if (!i18n.hasResourceBundle(Locales.fr, I18N_NS)) {
    i18n.addResourceBundle(Locales.fr, I18N_NS, frTranslation, true, true);
} else {
    i18n.addResourceBundle(Locales.fr, I18N_NS, frTranslation, true, true);
}

// Datepicker localization
Object.entries(locales).forEach(([key, value]) => registerLocale(key, value));
setDefaultLocale(Locales.en);
